// Column ids, in Figma's order. The fulfillments route has no sort support, so no column is sortable.
export const ALLOCATION_COLUMNS = Object.freeze({
  transactionId: 'transactionId',
  declarationNo: 'declarationNo',
  materialName: 'materialName',
  facilityName: 'facilityName',
  terminal: 'terminal',
  status: 'status',
  internalTransfer: 'internalTransfer',
  sendTo: 'sendTo',
  shippingTo: 'shippingTo',
  transactionDate: 'transactionDate',
  unitType: 'unitType',
  certifiedQuantity: 'certifiedQuantity',
  massBalancePeriod: 'massBalancePeriod',
  reference: 'reference',
  associatedDeclarationNo: 'associatedDeclarationNo',
  declarations: 'declarations',
  transactedBy: 'transactedBy',
  countryOfOrigin: 'countryOfOrigin',
  rawMaterialType: 'rawMaterialType',
  ghgEmissions: 'ghgEmissions',
  ghgEmissionSavings: 'ghgEmissionSavings',
  feedstockCategory: 'feedstockCategory',
  allocatedQuota: 'allocatedQuota',
  dateOfDispatch: 'dateOfDispatch',
  daysLeft: 'daysLeft',
});

// Below which "Days left" turns red, matching incoming shipments.
export const URGENT_DAYS = 7;
